import React from 'react';
import { FaHeart } from 'react-icons/fa';
import './LandingFooter.css';

const LandingFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="landing-footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-slogan">
            <FaHeart className="slogan-icon" />
            <p>"L'amour véritable commence ici"</p>
          </div>
          
          <div className="footer-divider"></div>
          
          <div className="footer-copyright">
            <p>© {currentYear} Lova. Tous droits réservés.</p>
            <span className="footer-tagline">Fait avec 💕 pour les cœurs qui cherchent</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
